import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import CartApprovalScreen from "../../CartApprovalScreen";
import {
  prequalDataSelector,
  subscribingDataSelector,
} from "containers/MultistepForm/selectors";
import {
  nextStep,
  prequalEditCart,
  getRecommendationsForItem,
} from "containers/MultistepForm/actions";
import { logEvent } from "containers/EmbeddableWidget/actions";

class PrequalPartialScreen extends Component {
  getApprovalLimit = () => {
    const { prequalData } = this.props;
    return (
      prequalData.approval_amount_with_buffer || prequalData.approval_amount
    );
  };

  buildOffer = () => {
    const { prequalData } = this.props;
    return {
      provider: "progressive",
      specific_provider_name: "progressive",
      app_id: prequalData.app_id,
      approved_amount: this.getApprovalLimit(),
      payment_schedule: prequalData.pay_frequency,
      bank_data_is_required: false,
      type: "Lease to Own",
      options: [],
    };
  };

  handleContinue = () => {
    const { prequalData, nextStep } = this.props;
    const step =
      prequalData.status === "prequalified"
        ? "progressivePrequalOffer"
        : "progressivePrequalApproved";
    nextStep({ step, data: prequalData });
  };

  render() {
    const { prequalData, items, prequalEditCart, getRecommendationsForItem, logEvent } = this.props;

    if (!prequalData) return null;

    const lineItems = (items && items.line_items) || [];
    // Remount on cart changes so CartApprovalScreen drops stale pending edits.
    const cartKey = lineItems.map((i) => `${i.id}:${i.quantity}`).join("|");

    return (
      <CartApprovalScreen
        key={cartKey}
        mode="over"
        availableApplications={[]}
        notAvailableApplications={[this.buildOffer()]}
        items={items}
        cartAmount={prequalData.cart_total}
        editCart={prequalEditCart}
        selectOffer={this.handleContinue}
        getRecommendationsForItem={getRecommendationsForItem}
        logEvent={logEvent}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  prequalData: prequalDataSelector(),
  items: subscribingDataSelector(),
});

const mapDispatchToProps = (dispatch) => {
  return {
    nextStep: (payload) => dispatch(nextStep(payload)),
    prequalEditCart: (payload) => dispatch(prequalEditCart(payload)),
    getRecommendationsForItem: (payload) =>
      dispatch(getRecommendationsForItem(payload)),
    logEvent: (value) => dispatch(logEvent(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrequalPartialScreen);
